import React, {memo} from 'react';

import {DateRangePicker} from '@homeaway/react-date-pickers';

// DateRangePicker.whyDidYouRender = true;

import {useComponent} from './hooks/useComponent';

import './SearchDatesDetailsInputField.less';
import '../SearchDatesPicker/SearchDatesPicker.less';

const SearchDatesDetailsInputField = memo(function SearchDatesDetailsInputField() {
    const {
        className,
        actionLocation,
        alertTemplateComponent,
        alertTemplateData,
        calendarLabels,
        centered,
        clearButtonLabel,
        closeButtonLabel,
        consolidateInputs,
        continueButtonLabel,
        dateFormatOptions,
        dayData,
        dayTemplateComponent,
        directionsLabel,
        disableTextInput,
        displayYearFirst,
        enableSameDayDateRange,
        endDate,
        endDateText,
        fadeOut,
        fadeOutDuration,
        i18n,
        id,
        inputIcon1,
        inputIcon2,
        inputLabel1,
        inputLabel2,
        inputName1,
        inputName2,
        isMobile,
        isOpen,
        locale,
        maxDate,
        minDate,
        modalTitle,
        onCancel,
        onClose,
        onDateRangeChange,
        onDateRangeClear,
        onDisabledDayClick,
        onFocus,
        onOpen,
        onSelectionModeChange,
        onSubmit,
        parentNode,
        pickerClassName,
        placement,
        positionIconRight,
        readOnly,
        scrollNode,
        showArrow,
        showContinueButton,
        splitInputs,
        startDate,
        startDateText,
        useConsistentDayOfWeekExperiment,
        useHoverString,
        wdioPrefix
    } = useComponent();

    return (
        <div className={className}>
            <DateRangePicker
                actionLocation={actionLocation}
                alertTemplateComponent={alertTemplateComponent}
                alertTemplateData={alertTemplateData}
                calendarLabels={calendarLabels}
                centered={centered}
                className={pickerClassName}
                clearButtonLabel={clearButtonLabel}
                closeButtonLabel={closeButtonLabel}
                consolidateInputs={consolidateInputs}
                continueButtonLabel={continueButtonLabel}
                dateFormatOptions={dateFormatOptions}
                dayData={dayData}
                dayTemplateComponent={dayTemplateComponent}
                directionsLabel={directionsLabel}
                disableTextInput={disableTextInput}
                displayYearFirst={displayYearFirst}
                enableSameDayDateRange={enableSameDayDateRange}
                endDate={endDate}
                endDateText={endDateText}
                fadeOut={fadeOut}
                fadeOutDuration={fadeOutDuration}
                i18n={i18n}
                id={id}
                inputIcon1={inputIcon1}
                inputIcon2={inputIcon2}
                inputLabel1={inputLabel1}
                inputLabel2={inputLabel2}
                inputName1={inputName1}
                inputName2={inputName2}
                isOpen={isOpen}
                key={isMobile ? 1 : 0}
                locale={locale}
                maxDate={maxDate}
                minDate={minDate}
                modalTitle={modalTitle}
                onCancel={onCancel}
                onClose={onClose}
                onDateRangeChange={onDateRangeChange}
                onDateRangeClear={onDateRangeClear}
                onDisabledDayClick={onDisabledDayClick}
                onFocus={onFocus}
                onOpen={onOpen}
                onSelectionModeChange={onSelectionModeChange}
                onSubmit={onSubmit}
                parentNode={parentNode}
                placement={placement}
                positionIconRight={positionIconRight}
                readOnly={readOnly}
                scrollNode={scrollNode}
                showArrow={showArrow}
                showContinueButton={showContinueButton}
                splitInputs={splitInputs}
                startDate={startDate}
                startDateText={startDateText}
                useConsistentDayOfWeekExperiment={useConsistentDayOfWeekExperiment}
                useHoverString={useHoverString}
                wdioPrefix={wdioPrefix}
            />
        </div>
    );
});

SearchDatesDetailsInputField.whyDidYouRender = true;

export {SearchDatesDetailsInputField};
